export default {
  'top-start': {
    top: 0
  },
  'top-center': {
    left: 0,
    right: 0,
    marginHorizontal: 'auto'
  },
  'top-end': {
    top: 0,
    right: 0
  },
  'right-start': {
    top: 0,
    right: 0
  },
  'left-start': {
    top: 0
  },
  'left-center': {
    top: 0,
    bottom: 0,
    marginVertical: 'auto'
  },
  'none-start': {
    top: 0,
    bottom: 0,
    marginVertical: 'auto'
  },
  'none-center': {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    margin: 'auto'
  },
  'right-center': {
    top: 0,
    bottom: 0,
    right: 0,
    marginVertical: 'auto'
  },
  'none-end': {
    top: 0,
    bottom: 0,
    right: 0,
    marginVertical: 'auto'
  },
  'bottom-start': {
    bottom: 0,
    left: 0
  },
  'left-end': {
    bottom: 0,
    left: 0
  },
  'bottom-center': {
    left: 0,
    right: 0,
    bottom: 0,
    marginHorizontal: 'auto'
  },
  'bottom-end': {
    right: 0,
    bottom: 0
  },
  'right-end': {
    right: 0,
    bottom: 0
  },
  'top-stretch': {
    left: 0,
    right: 0,
    width: '100%'
  },
  'left-stretch': {
    top: 0,
    bottom: 0,
    height: '100%'
  },
  'right-stretch': {
    top: 0,
    bottom: 0,
    right: 0,
    height: '100%'
  },
  'bottom-stretch': {
    left: 0,
    right: 0,
    bottom: 0,
    width: '100%'
  }
};